module.exports = __webpack_public_path__ + "img/exam_ana.1f2fdf68.jpg";